import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { BookButton } from './BookButton';
import { PhotoPlaceholder } from './PhotoPlaceholder';
export function FinalCta() {
  return <section aria-labelledby="final-cta-heading" className="relative overflow-hidden border-t border-gold/30 bg-navy py-28 text-paper md:py-40" data-id="element-20" data-mp="19g0dhjtkbyky">
      <div className="absolute inset-0" data-id="element-21" data-mp="1jd50tmz5a03c">
        <PhotoPlaceholder variant="background" description="Wide, quiet photo: a veteran on a front porch at dusk, phone in hand. Calm and hopeful, not staged." alt="A veteran sitting on his front porch at dusk, holding his phone." supplySize="2880 × 1400 px or larger" data-id="element-22" data-mp="1jc3hkv7z67aj" />
        <div aria-hidden="true" className="absolute inset-0 z-10 bg-navy/85" data-id="element-23" data-mp="1o4d9uhwkbjfz" />
      </div>

      <Reveal className="relative z-10 mx-auto max-w-3xl px-6 text-center md:px-10" data-id="element-24" data-mp="2245z08sfxrlu">
        <div aria-hidden="true" className="flex items-center justify-center gap-4" data-id="element-25" data-mp="1x5l14g0nvk0k">
          <span className="h-px w-12 bg-gold" data-id="element-26" data-mp="n6e47joasdvb" />
          <StarIcon className="h-4 w-4 fill-gold text-gold" strokeWidth={1} data-id="element-27" data-mp="n7p77h9x5hld" />
          <span className="h-px w-12 bg-gold" data-id="element-28" data-mp="s57gx9vrg0uf" />
        </div>
        <h2 id="final-cta-heading" className="mt-8 font-serif text-4xl font-semibold leading-tight md:text-6xl" data-id="element-29" data-mp="x38yfqdjfs3s">
          Not sure where to start? Start with a conversation.
        </h2>
        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-paper/85 md:text-xl" data-id="element-30" data-mp="164qbt0zk9fos">
          One free call. Tell us what happened. We'll tell you honestly how we can help.
        </p>
        <div className="mt-12 flex flex-col items-center gap-6" data-id="element-31" data-mp="1fujns33m7wtk">
          <BookButton data-id="element-32" data-mp="1fv1q9hgvf79x" />
          <a href="/contact-us" className="text-lg font-medium text-paper underline decoration-gold/70 underline-offset-[6px] transition-colors duration-150 ease-out hover:text-gold" data-id="element-33" data-mp="1ktd21xqq7rus">
            Contact Us
          </a>
        </div>
      </Reveal>
    </section>;
}